// extracted by mini-css-extract-plugin
export default {"user__photo":"progress-report_user__photo__glJhM","user__card":"progress-report_user__card__KAPuD","rate__text":"progress-report_rate__text__gWJLh"};